export default __webpack_public_path__ + "static/media/Rectangle 504.44bb5071.png";